import api from "./Api";

class OrdemServicoEnderecoEntregaService {
  GetOrdemServicoEnderecoEntrega(payload) {
    return api
      .get("/v1/ordemServicoEnderecoEntrega/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostOrdemServicoEnderecoEntrega(payload) {
    return api
      .post("/v1/ordemServicoEnderecoEntrega/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutOrdemServicoEnderecoEntrega(payload) {
    return api
      .put("/v1/ordemServicoEnderecoEntrega/", payload)
      .then((response) => {
        return response.data;
      });
  }

  DeleteOrdemServicoEnderecoEntrega(payload) {
    return api
      .delete("/v1/ordemServicoEnderecoEntrega/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetOrdemServicoEnderecoEntregaOData(payload) {
    return api
      .get("/OData/OrdemServicoEnderecoEntrega" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new OrdemServicoEnderecoEntregaService();
